module.exports = __webpack_public_path__ + "static/media/home_litonail.d7c10d4b.png";